export function Videos() {
  return (
    <h1 className="text-center">Videos</h1>
  )
}